export default {
  PROJECT_UNIT_LAYOUT_SET_LOADING: 'PROJECT_UNIT_LAYOUT_SET_LOADING',

  PROJECT_UNIT_LAYOUT_REQUEST: 'PROJECT_UNIT_LAYOUT_REQUEST',
  PROJECT_UNIT_LAYOUT_FAILURE: 'PROJECT_UNIT_LAYOUT_FAILURE',
  PROJECT_UNIT_LAYOUT_SUCCESS: 'PROJECT_UNIT_LAYOUT_SUCCESS',

  PROJECT_UNIT_LAYOUT_RESET: 'PROJECT_UNIT_LAYOUT_RESET',
};
